module.exports = "https://p.cds.unp.clasificados.pe/open-sans-regular.ffc14993d2c44d9bb100bed4c06c726c.woff2";